export const districtData = [
  {
    id: 72,
    name: "Abu Dhabi, UAE"
  },
  {
    id: 75,
    name: "Ajman, UAE"
  },
  {
    id: 117,
    name: "Al Khobar, Saudi Arabia"
  },
  {
    id: 111,
    name: "Al Khor, Qatar"
  },
  {
    id: 110,
    name: "Ar Rayyan, Qatar"
  },
  {
    id: 55,
    name: "Bagerhat, Bangladesh"
  },
  {
    id: 77,
    name: "Bali, Indonesia"
  },
  {
    id: 40,
    name: "Bandarban, Bangladesh"
  },
  {
    id: 79,
    name: "Bandung, Indonesia"
  },
  {
    id: 138,
    name: "Bangalore, India"
  },
  {
    id: 130,
    name: "Bangkok, Thailand"
  },
  {
    id: 34,
    name: "Barguna, Bangladesh"
  },
  {
    id: 35,
    name: "Barisal, Bangladesh"
  },
  {
    id: 102,
    name: "Bhaktapur, Nepal"
  },
  {
    id: 36,
    name: "Bhola, Bangladesh"
  },
  {
    id: 18,
    name: "Bogra, Bangladesh"
  },
  {
    id: 41,
    name: "Brahmanbaria, Bangladesh"
  },
  {
    id: 122,
    name: "Bugis, Singapore"
  },
  {
    id: 42,
    name: "Chandpur, Bangladesh"
  },
  {
    id: 140,
    name: "Chennai, India"
  },
  {
    id: 133,
    name: "Chiang Mai, Thailand"
  },
  {
    id: 43,
    name: "Chittagong, Bangladesh"
  },
  {
    id: 101,
    name: "Chitwan, Nepal"
  },
  {
    id: 56,
    name: "Chuadanga, Bangladesh"
  },
  {
    id: 124,
    name: "Colombo, Sri Lanka"
  },
  {
    id: 44,
    name: "Comilla, Bangladesh"
  },
  {
    id: 45,
    name: "Coxs Bazar, Bangladesh"
  },
  {
    id: 118,
    name: "Dammam, Saudi Arabia"
  },
  {
    id: 1,
    name: "Dhaka, Bangladesh"
  },
  {
    id: 26,
    name: "Dinajpur, Bangladesh"
  },
  {
    id: 108,
    name: "Doha, Qatar"
  },
  {
    id: 71,
    name: "Dubai, UAE"
  },
  {
    id: 145,
    name: "Fahaheel, Kuwait"
  },
  {
    id: 2,
    name: "Faridpur, Bangladesh"
  },
  {
    id: 46,
    name: "Feni, Bangladesh"
  },
  {
    id: 146,
    name: "Free Trade Zone, Kuwait"
  },
  {
    id: 76,
    name: "Fujairah, UAE"
  },
  {
    id: 87,
    name: "Fukuoka, Japan"
  },
  {
    id: 27,
    name: "Gaibandha, Bangladesh"
  },
  {
    id: 3,
    name: "Gazipur, Bangladesh"
  },
  {
    id: 137,
    name: "Goa, India"
  },
  {
    id: 4,
    name: "Gopalganj, Bangladesh"
  },
  {
    id: 51,
    name: "Habiganj, Bangladesh"
  },
  {
    id: 128,
    name: "Hikkaduwa, Sri Lanka"
  },
  {
    id: 134,
    name: "Hua/ Cha-am, Thailand"
  },
  {
    id: 93,
    name: "Ipoh, Malaysia"
  },
  {
    id: 90,
    name: "Jahor Bahru Penang, Malaysia"
  },
  {
    id: 70,
    name: "Jakar, Bhutan"
  },
  {
    id: 78,
    name: "Jakarta, Indonesia"
  },
  {
    id: 5,
    name: "Jamalpur, Bangladesh"
  },
  {
    id: 147,
    name: "Jammu & Kashmir, India"
  },
  {
    id: 115,
    name: "Jeddah, Saudi Arabia"
  },
  {
    id: 57,
    name: "Jessore, Bangladesh"
  },
  {
    id: 37,
    name: "Jhalokati, Bangladesh"
  },
  {
    id: 58,
    name: "Jhenaidah, Bangladesh"
  },
  {
    id: 19,
    name: "Joypurhat, Bangladesh"
  },
  {
    id: 123,
    name: "Kallang, Singapore"
  },
  {
    id: 125,
    name: "Kandy, Sri Lanka"
  },
  {
    id: 99,
    name: "Kathmandu, Nepal"
  },
  {
    id: 47,
    name: "Khagrachari, Bangladesh"
  },
  {
    id: 59,
    name: "Khulna, Bangladesh"
  },
  {
    id: 6,
    name: "Kishoreganj, Bangladesh"
  },
  {
    id: 135,
    name: "Koh Samui, Thailand"
  },
  {
    id: 92,
    name: "Kota Kinabalu, Malaysia"
  },
  {
    id: 89,
    name: "Kuala Lumpur, Malaysia"
  },
  {
    id: 28,
    name: "Kurigram, Bangladesh"
  },
  {
    id: 60,
    name: "Kushtia, Bangladesh"
  },
  {
    id: 144,
    name: "Kuwait Airport Zone, Kuwait"
  },
  {
    id: 142,
    name: "Kuwait City Center, Kuwait"
  },
  {
    id: 141,
    name: "Kuwait, Kuwait"
  },
  {
    id: 85,
    name: "Kyoto, Japan"
  },
  {
    id: 48,
    name: "Lakshmipur, Bangladesh"
  },
  {
    id: 29,
    name: "Lalmonirhat, Bangladesh"
  },
  {
    id: 104,
    name: "Lumbini, Nepal"
  },
  {
    id: 7,
    name: "Madaripur, Bangladesh"
  },
  {
    id: 61,
    name: "Magura, Bangladesh"
  },
  {
    id: 91,
    name: "Malacca, Malaysia"
  },
  {
    id: 98,
    name: "Maldives Guest House, Maldives"
  },
  {
    id: 94,
    name: "Maldives Islands, Maldives"
  },
  {
    id: 97,
    name: "Maldives Resorts, Maldives"
  },
  {
    id: 96,
    name: "Maldives, Maldives"
  },
  {
    id: 95,
    name: "Male City and airport, Maldives"
  },
  {
    id: 8,
    name: "Manikganj, Bangladesh"
  },
  {
    id: 52,
    name: "Maulvibazar, Bangladesh"
  },
  {
    id: 113,
    name: "Mecca, Saudi Arabia"
  },
  {
    id: 116,
    name: "Medina, Saudi Arabia"
  },
  {
    id: 62,
    name: "Meherpur, Bangladesh"
  },
  {
    id: 112,
    name: "Mesaieed, Qatar"
  },
  {
    id: 126,
    name: "Mirissa, Sri Lanka"
  },
  {
    id: 139,
    name: "Mumbai, India"
  },
  {
    id: 9,
    name: "Munshiganj, Bangladesh"
  },
  {
    id: 105,
    name: "Muscat, Oman"
  },
  {
    id: 10,
    name: "Mymensingh, Bangladesh"
  },
  {
    id: 103,
    name: "Nagarkot, Nepal"
  },
  {
    id: 20,
    name: "Naogaon, Bangladesh"
  },
  {
    id: 63,
    name: "Narail, Bangladesh"
  },
  {
    id: 11,
    name: "Narayanganj, Bangladesh"
  },
  {
    id: 12,
    name: "Narsingdi, Bangladesh"
  },
  {
    id: 21,
    name: "Natore, Bangladesh"
  },
  {
    id: 22,
    name: "Nawabganj, Bangladesh"
  },
  {
    id: 129,
    name: "Negombo, Sri Lanka"
  },
  {
    id: 13,
    name: "Netrokona, Bangladesh"
  },
  {
    id: 136,
    name: "New Delhi, India"
  },
  {
    id: 30,
    name: "Nilphamari, Bangladesh"
  },
  {
    id: 107,
    name: "Nizwa, Oman"
  },
  {
    id: 49,
    name: "Noakhali, Bangladesh"
  },
  {
    id: 127,
    name: "Nuwara Eliya, Sri Lanka"
  },
  {
    id: 86,
    name: "Okinawa Main Island, Japan"
  },
  {
    id: 121,
    name: "Orchard, Singapore"
  },
  {
    id: 84,
    name: "Osaka, Japan"
  },
  {
    id: 23,
    name: "Pabna, Bangladesh"
  },
  {
    id: 31,
    name: "Panchagarh, Bangladesh"
  },
  {
    id: 66,
    name: "Paro, Bhutan"
  },
  {
    id: 131,
    name: "Pattaya, Thailand"
  },
  {
    id: 38,
    name: "Patuakhali, Bangladesh"
  },
  {
    id: 132,
    name: "Phuket, Thailand"
  },
  {
    id: 67,
    name: "Phuntsholing, Bhutan"
  },
  {
    id: 39,
    name: "Pirojpur, Bangladesh"
  },
  {
    id: 100,
    name: "Pokhara, Nepal"
  },
  {
    id: 69,
    name: "Punakha, Bhutan"
  },
  {
    id: 14,
    name: "Rajbari, Bangladesh"
  },
  {
    id: 24,
    name: "Rajshahi, Bangladesh"
  },
  {
    id: 50,
    name: "Rangamati, Bangladesh"
  },
  {
    id: 32,
    name: "Rangpur, Bangladesh"
  },
  {
    id: 74,
    name: "Ras Al Khaimah, UAE"
  },
  {
    id: 114,
    name: "Riyadh, Saudi Arabia"
  },
  {
    id: 106,
    name: "Salalah, Oman"
  },
  {
    id: 143,
    name: "Salmiya, Kuwait"
  },
  {
    id: 88,
    name: "Sapporo, Japan"
  },
  {
    id: 64,
    name: "Satkhira, Bangladesh"
  },
  {
    id: 15,
    name: "Shariatpur, Bangladesh"
  },
  {
    id: 73,
    name: "Sharjah, UAE"
  },
  {
    id: 16,
    name: "Sherpur, Bangladesh"
  },
  {
    id: 119,
    name: "Singapore, Singapore"
  },
  {
    id: 25,
    name: "Sirajgonj, Bangladesh"
  },
  {
    id: 109,
    name: "Sumaysima, Qatar"
  },
  {
    id: 53,
    name: "Sunamganj, Bangladesh"
  },
  {
    id: 81,
    name: "Surabaya, Indonesia"
  },
  {
    id: 54,
    name: "Sylhet, Bangladesh"
  },
  {
    id: 17,
    name: "Tangail, Bangladesh"
  },
  {
    id: 82,
    name: "Tangerang, Indonesia"
  },
  {
    id: 33,
    name: "Thakurgaon, Bangladesh"
  },
  {
    id: 65,
    name: "Thimphu, Bhutan"
  },
  {
    id: 83,
    name: "Tokyo, Japan"
  },
  {
    id: 120,
    name: "Victoria, Singapore"
  },
  {
    id: 68,
    name: "Wangdue Phodrang, Bhutan"
  },
  {
    id: 80,
    name: "Yogyakarta, Indonesia"
  }
];
